(function() {
    // --- CONFIGURATION ---
    const CONFIG = {
        // The container for the Recharge widget
        widgetSelector: 'recharge-subscription-widget', 
        // The specific text span you want to change
        ctaSelector: '.product-form__submit > span',
        // Selectors inside the widget
        subRadioSelector: '.rc-purchase-option__subscription input[type="radio"]',
        oneTimeRadioSelector: '.rc-selection__onetime input[type="radio"]',
        // The text strings
        textSub: "Subscribe & Save",
        textOneTime: "Add to Cart"
    };

    // --- MAIN FUNCTION ---
    function updateCtaButtonText() {
        const shadowHost = document.querySelector(CONFIG.widgetSelector);
        const ctaSpan = document.querySelector(CONFIG.ctaSelector);

        // If the button doesn't exist yet, stop.
        if (!ctaSpan) return;

        // 1. Find the Radio Buttons (Check Shadow DOM first, then fallback to normal DOM)
        let subscribeRadio = null;

        if (shadowHost && shadowHost.shadowRoot) {
            subscribeRadio = shadowHost.shadowRoot.querySelector(CONFIG.subRadioSelector);
        } else {
            // Fallback for standard DOM (older widgets)
            subscribeRadio = document.querySelector(CONFIG.subRadioSelector);
        }

        // 2. THE LOGIC (Simplified for robustness)
        // If subscribe is found AND checked -> Change text.
        // ELSE (for any other state, including one-time) -> Revert to "Add to Cart".
        if (subscribeRadio && subscribeRadio.checked) {
            if (ctaSpan.textContent !== CONFIG.textSub) {
                ctaSpan.textContent = CONFIG.textSub;
                // console.log("CTA updated: " + CONFIG.textSub);
            }
        } else {
            // This 'else' guarantees it always reverts back if Sub isn't selected
            if (ctaSpan.textContent !== CONFIG.textOneTime) {
                ctaSpan.textContent = CONFIG.textOneTime;
                // console.log("CTA reverted: " + CONFIG.textOneTime);
            }
        }
    }

    // --- INITIALIZATION ---
    function initListeners() {
        const shadowHost = document.querySelector(CONFIG.widgetSelector);
        
        // We define a helper to attach listeners to both radios
        const attach = (element) => {
            if (element) {
                element.addEventListener('change', updateCtaButtonText);
                // Also listen for clicks just in case 'change' is swallowed
                element.addEventListener('click', updateCtaButtonText); 
            }
        };

        if (shadowHost && shadowHost.shadowRoot) {
            // Try to find both radios inside Shadow DOM
            const subRadio = shadowHost.shadowRoot.querySelector(CONFIG.subRadioSelector);
            const oneRadio = shadowHost.shadowRoot.querySelector(CONFIG.oneTimeRadioSelector);
            
            if (subRadio && oneRadio) {
                attach(subRadio);
                attach(oneRadio);
                return true; // Success: Listeners attached
            }
        } else {
            // Fallback: Try to find in main DOM
            const subRadio = document.querySelector(CONFIG.subRadioSelector);
            const oneRadio = document.querySelector(CONFIG.oneTimeRadioSelector);
            if (subRadio && oneRadio) {
                attach(subRadio);
                attach(oneRadio);
                return true; // Success
            }
        }
        return false; // Failed to find elements
    }

    // --- POLLING MECHANISM ---
    // This loops every 500ms to check if the widget has loaded yet.
    const checkInterval = setInterval(() => {
        const success = initListeners();
        if (success) {
            // 1. Run the update immediately to set correct initial state
            updateCtaButtonText(); 
            // 2. Stop checking, we are done
            clearInterval(checkInterval); 
            // console.log("Webtrends: Recharge widget found & listeners attached.");
        }
    }, 500);

    // Stop trying after 10 seconds to save memory if widget never loads
    setTimeout(() => clearInterval(checkInterval), 10000);

})();